const NewPaymentIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10 13.5021C10 14.3324 10.5988 15 11.3333 15H12.8343C13.473 15 13.992 14.418 13.992 13.6904C13.992 12.9116 13.6727 12.6291 13.2016 12.4494L10.7984 11.5506C10.3273 11.3709 10.008 11.097 10.008 10.3096C10.008 9.59058 10.5269 9 11.1657 9H12.6667C13.4012 9 14 9.66762 14 10.4979"
      stroke="#447AED"
      strokeWidth="1.3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12 8V16"
      stroke="#447AED"
      strokeWidth="1.3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M18.6663 12C18.6663 15.68 15.6797 18.6667 11.9997 18.6667C8.31967 18.6667 5.33301 15.68 5.33301 12C5.33301 8.32004 8.31967 5.33337 11.9997 5.33337"
      stroke="#447AED"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15 7H17M17 7H19M17 7V9M17 7V5"
      stroke="#447AED"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default NewPaymentIcon;
